module.exports = __webpack_public_path__ + "static/media/precise.358e14ee.jpg";